import { motion } from "framer-motion";

import warehouseImg from "./assets/warehouse.webp";

const HeroSection = () => {
  return (
    <section className="w-full bg-[#F8F8F8] pt-20 px-16 sm:px-16">
      <div className="w-full max-w-[1312px] mx-auto flex flex-col lg:flex-row items-center justify-between gap-10">
        {/* LEFT CONTENT */}
        <motion.div
          className="w-full lg:w-[60%]"
          initial={{ opacity: 0, y: 40 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6, ease: "easeOut" }}
          viewport={{ once: true }}
        >
          <p className="text-[13px] font-medium mb-3 uppercase tracking-wider">
            Warehouse management
          </p>
          <h1 className="text-[#212129] text-[24px] md:text-[44px] leading-[52px] md:leading-[52px] font-extrabold mb-[24px]">
            Smarter Warehousing
            <br className="hidden lg:block" />
            Starts Here
          </h1>
          <p className="text-[#212129] text-[15px] md:text-[15px] leading-[28px] md:leading-[25px] max-w-[530px]">
            Streamline your inventory, optimize space and track every movement —
            all in real time with our powerful Warehouse Management System.
          </p>
        </motion.div>

        {/* RIGHT IMAGE */}
       <motion.div
  className="w-full lg:w-[40%] flex justify-center lg:justify-end"
  initial={{ opacity: 0, scale: 0.9 }}
  whileInView={{ opacity: 1, scale: 1 }}
  transition={{ duration: 0.6, ease: "easeOut", delay: 0.2 }}
  viewport={{ once: true }}
>
  <img
    src={warehouseImg}
    alt="Warehouse illustration"
    className="w-full max-w-[520px] lg:max-w-[600px] xl:max-w-[700px] h-auto object-contain"
  />
</motion.div>
      </div>
    </section>
  );
};

export default HeroSection;
